
function ratingStarsInput() {
    const ratingContainers = document.querySelectorAll('.rating-stars');

    ratingContainers.forEach((container) => {
        const stars = Array.from(container.querySelectorAll('.rating-stars__star'));
        if (!stars.length) return;

        const targetSelector = container.getAttribute('data-target-input');
        const form = container.closest('form') || document;
        const ratingInput = targetSelector
            ? form.querySelector(targetSelector)
            : form.querySelector('[name="rating"], input.wpcf7-number, input[type="number"]');

        if (!ratingInput) return;

        const toValidValue = (value) => {
            const parsed = Number(value);
            if (!Number.isFinite(parsed)) return 0;
            return Math.max(0, Math.min(5, Math.round(parsed)));
        };

        let selectedValue = toValidValue(ratingInput.value);

        const paintStars = (value, className) => {
            stars.forEach((star) => {
                const starValue = Number(star.getAttribute('data-value'));
                if (starValue <= value) {
                    star.classList.add(className);
                } else {
                    star.classList.remove(className);
                }
            });
        };

        const commitValue = (value) => {
            selectedValue = value;
            ratingInput.value = String(value);
            ratingInput.dispatchEvent(new Event('input', { bubbles: true }));
            ratingInput.dispatchEvent(new Event('change', { bubbles: true }));
            paintStars(selectedValue, 'is-active');
        };

        paintStars(selectedValue, 'is-active');

        stars.forEach((star) => {
            const value = Number(star.getAttribute('data-value'));

            star.addEventListener('mouseenter', () => {
                paintStars(value, 'is-hover');
            });

            star.addEventListener('click', () => {
                commitValue(value);
            });

            star.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    commitValue(value);
                }
            });
        });

        container.addEventListener('mouseleave', () => {
            stars.forEach((star) => star.classList.remove('is-hover'));
        });
    });
}

function showHideReviewForm() {
    const toggleButtons = document.querySelectorAll('.biogram__reviews__add-form-button');
    const formContainer = document.querySelector('.biogram__reviews__add-form');

    if (!toggleButtons.length || !formContainer) return;

    const syncButtons = (isVisible) => {
        toggleButtons.forEach((button) => {
            button.setAttribute('aria-expanded', String(isVisible));
        });
    };

    syncButtons(formContainer.classList.contains('is-visible'));

    toggleButtons.forEach((button) => {
        button.addEventListener('click', () => {
            syncButtons(formContainer.classList.toggle('is-visible'));
        });
    });
}



document.addEventListener('DOMContentLoaded', () => {
    ratingStarsInput();
    showHideReviewForm();
});